import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "emh-stage-campaign-item__inner-wrapper" }
const _hoisted_2 = { class: "emh-stage-campaign-item__container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "emh-stage-campaign-item__image-gradient" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "emh-stage-campaign-item__image-gradient-mq4" }, null, -1)
const _hoisted_5 = { class: "emh-stage-campaign-item__content" }
const _hoisted_6 = { class: "wb-grid-container" }
const _hoisted_7 = { class: "emh-stage-campaign-item__content-text" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 0,
  class: "emh-stage-campaign-item__price"
}
const _hoisted_11 = { class: "emh-stage-campaign-item__actions" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "emh-stage-campaign-item__content-background" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CampaignImage = _resolveComponent("CampaignImage")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_CampaignTag = _resolveComponent("CampaignTag")!
  const _component_MonthlyPriceInformation = _resolveComponent("MonthlyPriceInformation")!
  const _component_PurchasePriceInformation = _resolveComponent("PurchasePriceInformation")!
  const _component_SecondaryButton = _resolveComponent("SecondaryButton")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_HideNotification = _resolveComponent("HideNotification")!

  return (_ctx.renderStageCampaignItem)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref: "hostElement",
        class: _normalizeClass(_ctx.elementClasses)
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: "emh-stage-campaign-item__image",
              onMousedown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleMouseDown && _ctx.handleMouseDown(...args))),
              onMousemove: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleMouseMove && _ctx.handleMouseMove(...args))),
              onMouseup: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleMouseUp && _ctx.handleMouseUp(...args)))
            }, [
              _createVNode(_component_CampaignImage, {
                "picture-sources": _ctx.pictureSources,
                "picture-fallback-img-src": _ctx.pictureFallbackImgSrc,
                "picture-description": _ctx.pictureDescription
              }, null, 8, ["picture-sources", "picture-fallback-img-src", "picture-description"]),
              _hoisted_3,
              _hoisted_4
            ], 32),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                (_ctx.isTrue(_ctx.showCampaignTag))
                  ? (_openBlock(), _createBlock(_component_CampaignTag, {
                      key: 0,
                      "campaign-tag-label": _ctx.campaignTagLabel
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_inline_svg, {
                          src: require('./assets/campaign.svg')
                        }, null, 8, ["src"])
                      ]),
                      _: 1
                    }, 8, ["campaign-tag-label"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("h2", {
                    class: "emh-stage-campaign-item__headline wb-type-heading-xl",
                    innerHTML: _ctx.headline
                  }, null, 8, _hoisted_8),
                  _createElementVNode("p", {
                    class: "emh-stage-campaign-item__description wb-type-copy",
                    innerHTML: _ctx.description
                  }, null, 8, _hoisted_9),
                  (_ctx.showPriceInformation)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        (_ctx.showMonthlyPriceInformation)
                          ? (_openBlock(), _createBlock(_component_MonthlyPriceInformation, {
                              key: 0,
                              language: _ctx.language,
                              product: _ctx.product,
                              locale: _ctx.locale,
                              country: _ctx.country,
                              "emh-config": _ctx.emhConfig,
                              "customer-type": _ctx.userContext,
                              "post-code": _ctx.postCode,
                              t: _ctx.t,
                              onFcisError: _ctx.handleFcisError,
                              onFcisQuote: _ctx.handleFcisReady,
                              onFcisPopupToggle: _ctx.handlePopupToggle
                            }, null, 8, ["language", "product", "locale", "country", "emh-config", "customer-type", "post-code", "t", "onFcisError", "onFcisQuote", "onFcisPopupToggle"]))
                          : _createCommentVNode("", true),
                        (_ctx.showPurchasePriceInformation)
                          ? (_openBlock(), _createBlock(_component_PurchasePriceInformation, {
                              key: 1,
                              language: _ctx.language,
                              product: _ctx.product,
                              locale: _ctx.locale,
                              "pls-environment": _ctx.plsEnvironment,
                              "emh-config": _ctx.emhConfig,
                              "price-event-data": _ctx.priceEventData,
                              country: _ctx.country,
                              "footnote-references": _ctx.footnoteReferences,
                              "user-context": _ctx.userContext,
                              t: _ctx.t,
                              "post-code": _ctx.postCode,
                              onOnPpBreakdownToggle: _ctx.onPpBreakdownToggle,
                              onPriceDisplayDataUpdate: _ctx.onPriceDisplayDataUpdate,
                              onScrollToFootnotes: _ctx.scrollToFootnotes
                            }, null, 8, ["language", "product", "locale", "pls-environment", "emh-config", "price-event-data", "country", "footnote-references", "user-context", "t", "post-code", "onOnPpBreakdownToggle", "onPriceDisplayDataUpdate", "onScrollToFootnotes"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  (_ctx.secondaryLink && _ctx.secondaryLabel)
                    ? (_openBlock(), _createBlock(_component_SecondaryButton, {
                        key: 0,
                        "secondary-link": _ctx.secondaryLink,
                        "secondary-label": _ctx.secondaryLabel,
                        onButtonClick: _ctx.handleButtonClick
                      }, null, 8, ["secondary-link", "secondary-label", "onButtonClick"]))
                    : _createCommentVNode("", true),
                  (_ctx.ctaLink && _ctx.ctaLabel)
                    ? (_openBlock(), _createBlock(_component_PrimaryButton, {
                        key: 1,
                        "cta-link": _ctx.ctaLink,
                        "cta-label": _ctx.ctaLabel,
                        onButtonClick: _ctx.handleButtonClick
                      }, null, 8, ["cta-link", "cta-label", "onButtonClick"]))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_12
              ])
            ])
          ]),
          (_ctx.showHideNotificationComponent)
            ? (_openBlock(), _createBlock(_component_HideNotification, {
                key: 0,
                t: _ctx.t
              }, null, 8, ["t"]))
            : _createCommentVNode("", true)
        ])
      ], 2))
    : _createCommentVNode("", true)
}